var getVariant = function getVariant(p) {
  return p.variant ? p.variant : p.$variant;
};

export { getVariant };
